import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'

export const LabelerForm = () => {

  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.validators = [(value) => {
      if (!/^\d{5}$/.test(value)) {
        return 'A Labeler code must be 5 digits';
      }
      return null;
    }]

    fieldToFieldDef.code.maxChars = 5;
  }

  return (
    <EntityForm augFieldDefs={augFieldDefs} />
  )
}